export default __webpack_public_path__ + "static/media/yaakov.36add8ed.jpg";